<template>
  <footer class="pt-4 my-md-5 pt-md-5 border-top">
    <div class="row">
      <p class="fs-5 text-muted">
        测试结果会受代理软件或者其他加速器影响，建议线关闭之后再次刷新页面，避免因当前节点不可用导致不可访问。</p>
    </div>
  </footer>
</template>
<style>
</style>
<script setup>
</script>